import React from 'react';
export const CFIconRepeat = {
    alias: 'repeat',
    defaultTitle: 'Repeat',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M5.914 5H17.91c1.98 0 3.59 1.583 3.59 3.53V11a1 1 0 1 1-2 0V8.53c0-.843-.713-1.53-1.59-1.53H5.914l1.293 1.293a1 1 0 0 1-1.414 1.414l-3-3a.999.999 0 0 1 0-1.414l3-3a.999.999 0 1 1 1.414 1.414L5.914 5Zm10.879 9.293a.999.999 0 0 1 1.414 0l3 3a.999.999 0 0 1 0 1.414l-3 3a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L18.086 19H6.09c-1.98 0-3.59-1.583-3.59-3.529V13a1 1 0 1 1 2 0v2.471c0 .843.713 1.529 1.59 1.529h11.996l-1.293-1.293a.999.999 0 0 1 0-1.414Z' }))),
};
